import { Hairline, Message, Textarea } from "@components";
import { If } from "shared/components/control-statements";
import { TestShootingCard } from "./FormSteps/TestShootingCard";

import styles from "@styles/containers/cashback-programs/receive-remind.module.scss";
import { Environment } from "shared/core/Environment";
import { Currency } from "shared/utils/Currency";
import { Utils } from "shared/utils/Utils";
import { PointValue } from "shared/core/program/PointValue";
import { CashbackValue } from "shared/core/program/CashbackValue";

export const CashbackMessage = ({
  onChange,
  cashbackProgram,
  programLabels,
  template,
}) => {
  let MAX_CHARS_PER_SMS = 150;
  const isCocoBambu = Environment.id === 49;

  if (isCocoBambu) MAX_CHARS_PER_SMS = 145;

  const handleMessage = (value) => {
    const filteredValue = value.replace(
      /[\u{1F000}-\u{1F9FF}\u{1FA70}-\u{1FAFF}\u{2000}-\u{3300}\u{E000}-\u{F8FF}]+/gu,
      ""
    );

    onChange(filteredValue);
  };

  const buildExampleValue = () => {
    const exampleValue = cashbackProgram?.type === "POINT" ? 10 : 1.41;

    const formattedValue =
      cashbackProgram?.type === "POINT"
        ? PointValue.format(exampleValue, programLabels)
        : CashbackValue.format(exampleValue, programLabels);

    return formattedValue;
  }

  const replaceTags = (template) => {
    const message = template || "";

    const exampleValue = buildExampleValue();

    const tagPairs = [
      {
        from: /\<link\>/gi,
        to: `${Environment.defaultShortUrl}?q=5599999999999`,
      },
      {
        from: /\<valorrecebido\>/gi,
        to: exampleValue,
      },
    ];

    return tagPairs?.reduce(
      (str, tag) => str?.replace(tag.from, tag.to),
      Utils.removeAccents(String(message))
    );
  };

  const replaceGaps = (template) => {
    const message = template || "";

    const exampleValue = buildExampleValue();

    const tagPairs = [
      {
        from: "<link>",
        to: `<span style="color:#6161ff">${Environment.defaultShortUrl}?q=5599999999999</span>`,
      },
      {
        from: "<valorrecebido>",
        to: `<span style="color:#6161ff">${exampleValue}</span>`,
      },
    ];

    return tagPairs?.reduce(
      (str, tag) => str?.replace(tag.from, tag.to),
      Utils.removeAccents(String(message))
    );
  };

  const getMountedTemplate = () => {
    return replaceTags(template);
  };

  const getTotalSMS = () => {
    const final = getMountedTemplate();
    return Math.ceil(`${final}`.length / MAX_CHARS_PER_SMS);
  };

  const getTotalChars = () => {
    const final = getMountedTemplate();
    return `${final}`.length;
  };

  const SmsCounters = () => {
    return (
      <div className="d-flex justify-end">
        <p className={styles.smsCount}>
          <span className={styles.number}>{getTotalSMS()}</span>
          <span className={styles.type}>
            &nbsp;{getTotalSMS() > 1 ? "mensagens" : "mensagem"}
          </span>
          <span className={styles.number}>{getTotalChars()}</span>
          <span className={styles.type}>&nbsp;caracteres</span>
        </p>
      </div>
    );
  };

  return (
    <>
      <div className={styles.useOfTags}>
        <p className={styles.message}>
          Utilize as tags a seguir para construir sua mensagem, e veja uma
          pré-visualização completa da mensagem logo abaixo.
        </p>

        <div className="d-flex flex-column align-center">
          <span className={styles.tag}>&lt; link &gt;</span>
          <span className={styles.tag}>&lt; valorrecebido &gt;</span>
        </div>

        <p className={styles.required}>
          O uso das tags é obrigatório e não será possível avançar sem
          inseri-las na mensagem.
        </p>
      </div>

      <div>
        <p className={styles.label}>Escreva a mensagem que será enviada</p>
        <Textarea
          className="mt-20"
          floatLabel="Mensagem"
          design="two"
          onChange={(e) => handleMessage(e.target.value)}
          value={template}
        />
        <SmsCounters />

        <If cond={getTotalSMS() > 1}>
          <Message className="mt-20 mb-30">
            A cada 150 caracteres utilizados é realizado 1 disparo. Na mensagem
            definida nesse momento, 2 ou mais disparos serão realizados. Mas não
            se preocupe, seu cliente verá tudo como uma mensagem única.
          </Message>
        </If>

        <p className={styles.label}>Pré-visualização</p>
        <pre
          className={styles.previewMessage}
          dangerouslySetInnerHTML={{
            __html: replaceGaps(template) || ``,
          }}
        ></pre>
      </div>

      <Hairline />

      <TestShootingCard
        message={template}
        url={{ type: "STANDARD", value: Environment.defaultShortUrl }}
        beneficio={{
          type: "CASHBACK_PROGRAM",
          value: cashbackProgram?.percentage,
        }}
        valorrecebido={1.41}
      />
    </>
  );
};
